import { readyImage, type GameData } from '../../data/gameData.ts';
import { cachedPixelSource, type PixelSource } from '../sim/pixels.ts';

/** Texture alpha through a canvas (the textures are already decoded by loadGameData). */
export function browserPixelSource(gd: GameData): PixelSource {
  let canvas: HTMLCanvasElement | null = null;
  return cachedPixelSource((tex) => {
    const img = readyImage(gd.images.get(tex));
    if (!img) return null;
    canvas ??= document.createElement('canvas');
    const w = img.width, h = img.height;
    canvas.width = w;
    canvas.height = h;
    const g = canvas.getContext('2d', { willReadFrequently: true })!;
    g.clearRect(0, 0, w, h);
    g.drawImage(img, 0, 0);
    const rgba = g.getImageData(0, 0, w, h).data;
    const data = new Uint8Array(w * h);
    for (let i = 0; i < data.length; i++) data[i] = rgba[i * 4 + 3];
    return { w, h, data };
  });
}
